"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var TextField_1 = require("@material-ui/core/TextField");
var GenericInputStyles_1 = require("./GenericInputStyles");
var clsx_1 = require("clsx");
var core_1 = require("@material-ui/core");
var DateRange_1 = require("@material-ui/icons/DateRange");
var Help_1 = require("@material-ui/icons/Help");
var TextTooltip_1 = require("../../../../summary/components/common/TextTooltip/TextTooltip");
var Translation_1 = require("../../../../common/components/presentation/Translation/Translation");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var useWidgetContext_1 = require("../../../../common/react/useWidgetContext");
var usePriceFormatter_1 = require("../../../../../../common/react/usePriceFormatter");
exports.GenericInput = function (_a) {
    var _b;
    var label = _a.label, required = _a.required, id = _a.id, onChange = _a.onChange, value = _a.value, currentError = _a.currentError, inputLabel = _a.inputLabel, type = _a.type, datePicker = _a.datePicker, toggleDatePicker = _a.toggleDatePicker, phoneWithPrefix = _a.phoneWithPrefix, params = _a.params, tooltip = _a.tooltip, placeholder = _a.placeholder, readOnly = _a.readOnly, disabled = _a.disabled, endAdornment = _a.endAdornment, dataTest = _a["data-test"], inputMode = _a.inputMode, displayCurrency = _a.displayCurrency, showRequiredInPlaceholder = _a.showRequiredInPlaceholder, classes = _a.classes;
    var _c, _d, _e, _f;
    var styles = GenericInputStyles_1.default();
    var currency = usePlatformConfig_1.default().platformConfig.priceDisplay.primary.currency;
    var dimensions = useWidgetContext_1.default().configuration.dimensions;
    var priceFormatter = usePriceFormatter_1.default({
        currency: currency,
        decimals: 0,
        dimensions: {
            country: dimensions.country,
            language: dimensions.language,
        },
    });
    var displayRequiredInPlaceholder = showRequiredInPlaceholder !== undefined ? showRequiredInPlaceholder && required : required;
    return (<div ref={(_d = (_c = params) === null || _c === void 0 ? void 0 : _c.InputProps) === null || _d === void 0 ? void 0 : _d.ref} className={styles.fieldWrapper}>
      {inputLabel !== false && (<core_1.Box display={'flex'}>
          <core_1.Typography component="span" variant="subtitle1">
            <core_1.InputLabel htmlFor={id} required={required} className={styles.label} data-test={"text_input:label:" + id}>
              {label}
            </core_1.InputLabel>
          </core_1.Typography>
          {tooltip && (<TextTooltip_1.default id={id} text={tooltip} content={<core_1.Box component="span">
                  <Help_1.default className={styles.tooltipIcon} color="primary" viewBox="0 0 28 28"/>
                </core_1.Box>}/>)}
        </core_1.Box>)}
      <TextField_1.default inputMode={inputMode} data-test={dataTest || "text_input:" + id} id={id} type={type} variant="outlined" className={clsx_1.default([styles.input, (_b = {}, _b[styles.inputNoLabel] = inputLabel == false, _b)])} placeholder={(placeholder !== null && placeholder !== void 0 ? placeholder : "" + label + (displayRequiredInPlaceholder ? ' *' : ''))} value={(value !== null && value !== void 0 ? value : '')} error={!!currentError} onChange={onChange} disabled={disabled} helperText={currentError && (<core_1.Typography component="span" className={styles.errorText} data-test={"text_input:error:" + id}>
              {currentError}
            </core_1.Typography>)} InputProps={{
        readOnly: readOnly,
        classes: {
            root: styles.root,
            focused: styles.focused,
            error: styles.inputError,
            notchedOutline: styles.notchedOutline,
            disabled: styles.disabled,
        },
        endAdornment: endAdornment ? (endAdornment) : (<core_1.InputAdornment position="end">
              {datePicker && (<core_1.IconButton onClick={function () { return toggleDatePicker(true); }} component="span" className={styles.dateCalendar}>
                  <DateRange_1.default fontSize="small"/>
                </core_1.IconButton>)}
            </core_1.InputAdornment>),
        startAdornment: (<core_1.InputAdornment position="start" className={clsx_1.default([styles.phonePrefixBox, (_e = classes) === null || _e === void 0 ? void 0 : _e.startAdornment])}>
              {phoneWithPrefix && (<span className={styles.phonePrefix}>
                  <Translation_1.default id={'trans__checkout__enquiry_form__phone_prefix'}/>
                </span>)}
              {displayCurrency && priceFormatter.format(0).replace('0', '')}
            </core_1.InputAdornment>),
    }} FormHelperTextProps={{
        classes: {
            root: styles.helperTextError,
        },
    }} {...(_f = params) === null || _f === void 0 ? void 0 : _f.inputProps}/>
    </div>);
};
exports.default = exports.GenericInput;
